import {
  call,
  put,
  select,
  takeLatest,
  takeEvery,
  actionChannel,
} from 'redux-saga/effects';
import {
  loadingStatus,
  savingStatus,
  savingStatusFailed,
  statusLoaded,
  statusLoadingFailed,
  statusSaved,
  submittingSurvey,
  surveySubmissionFailed,
  surveySubmitted
} from "redux/checkIn/actions";
import {
  selectCheckInStatus,
  selectLastLoadingError,
  selectLoading,
  selectPreviousStatus,
  selectStatusMeta,
  selectSubmittingSurvey
} from "redux/checkIn/selectors";
import { fetchStatus, pushStatus } from "services/checkIn/checkIn";
import { selectPatientId } from "redux/reducers/session";
import { buffers } from "redux-saga";

export const LOAD_CHECK_IN_STATUS = "checkIn/load-status"

export function loadCheckInStatus() {
  return { type: LOAD_CHECK_IN_STATUS }
}

export function* watchForLoadCheckInStatus() {
  yield takeLatest(LOAD_CHECK_IN_STATUS, function* () {
    try {
      yield put(loadingStatus())
      const status = yield call(() => fetchStatus())
      yield put(statusLoaded(status))

    } catch (error) {
      yield put(statusLoadingFailed(error))
    }
  });
}

function* saveCheckInStatus() {
  try {
    yield put(savingStatus())
    const patientId = yield select(selectPatientId)
    const status = yield select(selectCheckInStatus)
    const meta = yield select(selectStatusMeta)
    const savingOutcomeBundle = yield call(() => pushStatus(patientId, Object.assign({}, status, meta)))
    yield put(statusSaved(savingOutcomeBundle, status))

  } catch (error) {
    yield put(savingStatusFailed(error))
    throw error
  }
}

export const AUTO_SAVE_CHECK_IN_STATUS = "checkIn/auto-save"

export function autoSaveCheckInStatus() {
  return { type: AUTO_SAVE_CHECK_IN_STATUS }
}

export function* watchForAutoSaveCheckInStatus() {
  const latestRequestOnly = yield actionChannel(
    AUTO_SAVE_CHECK_IN_STATUS,
    buffers.sliding(1)
  )
  yield takeEvery(latestRequestOnly, function* () {
    const status = yield select(selectCheckInStatus)
    const previousStatus = yield select(selectPreviousStatus)
    if (previousStatus === status) return

    const loading = yield select(selectLoading)
    const lastLoadingError = yield select(selectLastLoadingError)
    const submitting = yield select(selectSubmittingSurvey)
    if (submitting || loading || lastLoadingError) return

    try { yield call(saveCheckInStatus) } catch (_) {}
  })
}

export const SUBMIT_SURVEY = "checkIn/submit-survey"

export function submitSurvey() {
  return { type: SUBMIT_SURVEY }
}

export function* watchForSubmitSurvey() {
  yield takeLatest(SUBMIT_SURVEY, function* () {
    try {
      yield put(submittingSurvey())
      yield call(saveCheckInStatus)
      yield put(surveySubmitted())

    } catch (error) {
      yield put(surveySubmissionFailed(error))
    }
  })
}